export default __webpack_public_path__ + "static/colin_head-7b3b0283d0578fcc8b4aeaed821f01bd.png";